<template>
    <div class="wework-steps-box">
        <v-steps
            :titles="stepTitles"
            :index="currStepIndex"
        />
        <step-install
            v-if="currStepKey === 'install_app'"
            :is-last-step="isLastStep"
            @stepComplete="onStepComplete"
        />
        <step-auth
            v-else-if="currStepKey === 'authorize'"
            :is-last-step="isLastStep"
            @stepComplete="onStepComplete"
        />
        <step-sync
            v-else-if="currStepKey === 'sync'"
            :is-last-step="isLastStep"
            @stepComplete="onStepComplete"
        />
    </div>
</template>

<script>
import setFlowNext from '@/pages/mng/third_account/weworkCombine/api/setFlowNext';
import StepInstall from '../../step-install';
import StepAuth from '../../step-auth';
import StepSync from '../../step-sync';

export default {
    components: {
        StepInstall,
        StepAuth,
        StepSync,
    },

    props: {
        stepKeyList: {
            type: Array,
            default() {
                return [];
            },
        },
        stepKey: {
            type: String,
            default: 'install_app',
        },
        stepIndex: {
            type: Number,
            default: 1,
        },
    },

    data() {
        const stepKeyTitleMap = {
            install_app: '授权添加应用',
            authorize: '授权通讯录',
            sync: '开启通讯录同步',
        };

        const stepKeyIndexMap = {};
        const stepIndexKeyMap = {};
        const stepTitles = [];

        this.stepKeyList.forEach((v, index) => {
            stepTitles.push(stepKeyTitleMap[v]);
            stepIndexKeyMap[index + 1] = v;
            stepKeyIndexMap[v] = index + 1;
        });

        return {
            stepTitles,
            stepIndexKeyMap,
            currStepIndex: stepKeyIndexMap[this.stepKey],
        };
    },

    computed: {
        currStepKey() {
            return this.stepIndexKeyMap[this.currStepIndex];
        },

        isLastStep() {
            return this.currStepIndex >= this.stepKeyList.length;
        },
    },

    methods: {
        onStepComplete() {
            setFlowNext(this.currStepKey)
                .then(() => {
                    if (this.isLastStep) {
                        window.location.reload();
                    } else {
                        this.currStepIndex = this.currStepIndex + 1;
                    }
                })
                .catch((msg) => {
                    this.$message.error(msg);
                });
        },
    },
};
</script>
